import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

import { DEFAULT_REDIRECT_ROUTE, RoutePath } from "./config/routing.config";
import { AuthGuard } from "./shared/utils/auth.guard";

const routes: Routes = [
	{
		path: RoutePath.Login,
		loadChildren: () => import("src/app/views/login/login.module").then((m) => m.LoginModule),
	},
	{
		path: RoutePath.List,
		loadChildren: () => import("src/app/views/list/list.module").then((m) => m.ListModule),
		canActivate: [AuthGuard],
	},
	{
		path: RoutePath.Roadwork,
		loadChildren: () => import("src/app/views/roadwork/roadwork.module").then((m) => m.RoadworkModule),
		canActivate: [AuthGuard],
	},
	{ path: "**", redirectTo: DEFAULT_REDIRECT_ROUTE, pathMatch: "full" },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule],
	providers: [AuthGuard],
})
export class AppRoutingModule {}
